<template>
  <v-navigation-drawer fixed permanent class="sidenav">
      <v-card justify-center>
        <v-card-media>
          <img class="navlogo" src="~icons/taskorganizer/nav-logo.svg" alt="">
        </v-card-media>
      </v-card>
      <v-divider></v-divider>
      <v-list class="pt-0 side">
        <v-list-tile @click="onActiveTabChange('organize');" class="sidenav-elements">
          <v-btn flat block large>
            <v-list-tile-action>
              <v-icon medium class="organize-icon" :class="menuActive('organize')">outlined_flag</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title >
                <span class="nav__text" :class="menuActive('organize')">Organize</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-btn>
        </v-list-tile>
        <v-list-tile @click="onActiveTabChange('tasks')" class="sidenav-elements" >
          <v-btn flat block large>
            <v-list-tile-action>
              <i class="tasks-icon" :class="menuActive('tasks')"></i>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class='nav__text' :class="menuActive('tasks')">Effort</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-btn>
        </v-list-tile>
        <v-list-tile @click="onActiveTabChange('messages')" class="sidenav-elements">
          <v-btn flat block large>
            <v-list-tile-action>
              <i class ='message-icon' :class="menuActive('messages')"></i>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class='nav__text' :class="menuActive('messages')">Messages</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-btn>
        </v-list-tile>
        <v-list-tile @click="onActiveTabChange('profile')" class="sidenav-elements">
          <v-btn flat block large>
            <v-list-tile-action>
              <i class='profile-icon' :class="menuActive('profile')" ></i>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class='nav__text' :class="menuActive('profile')">Profile</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-btn>
        </v-list-tile>
      </v-list>
  </v-navigation-drawer>

</template>

<script>
import navigation from '@/mixins/navigation';

export default {
  mixins: [navigation],
  props: ['activeTab'],
  data() {
    return {
    };
  },
  methods: {
    menuActive(item) {
      const active = this.activeTab === item;
      return { active };
    },
    onActiveTabChange(value) {
      this.navigate(value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/shared.scss";

  .sidenav {
    display: none;
    background: $menu-black;
    max-height: 100%;
    z-index: 999;
  }

  @media only screen and (min-width:1600px) {
    .sidenav {
      display: inherit;
    }
  }

  .navlogo {
    padding: 60px;
  }
  .sidenav .card {
    background: $menu-black;
  }
  .sidenav .nav__text.active {
    color: $white;
    opacity: 1;
    font-size: 14px;
    font-family: MuseoSans-500;
    font-weight: bold;
  }

  .sidenav .nav__text {
    color: $white;
    opacity: 0.5;
    font-size: 14px;
    font-family: MuseoSans-500;
  }

  .sidenav a {
    padding: 0px;
  }

  .sidenav .btn {
    height: 100%;
  }


.organize-icon {
  color: #939596 !important;
}

.organize-icon.active {
  color: #ffc175 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue